export default __webpack_public_path__ + "static/media/f.936c2ba9.png";